import { useEffect } from 'react';
import { create } from 'zustand';
import toast from 'react-hot-toast';
import DashboardController from '@/services/DashboardController';

// New requests from the public website's interest form (Επισκόπηση →
// «Αιτήματα από το site»), for masters only: the number on «Επισκόπηση» and
// on the Live bell, and a pop-up when one arrives while the app is open.
// Polled once a minute — the requests come from outside, with no socket.

const POLL_MS = 60 * 1000;

const ROLE_LABELS = { shop: 'Κατάστημα', rider: 'Διανομέας', fleet: 'Στόλος' };

export const useInterestStore = create((set, get) => ({
	newCount: 0,
	// Highest request id already seen, so only newer ones pop up. null until
	// the first answer: what was waiting at login doesn't pop up.
	seenId: null,
	refresh: async () => {
		const res = await DashboardController.getInterestRequestsCount();
		if (res?.error) return;
		const latest = res.latestNew;
		const { seenId } = get();
		if (seenId !== null && latest && latest.id > seenId) {
			toast(`Νέο αίτημα από το site: ${ROLE_LABELS[latest.role] || latest.role} — ${latest.city}`, {
				icon: '🔔',
				duration: 8000,
			});
		}
		set({
			newCount: res.newCount || 0,
			seenId: Math.max(seenId ?? 0, latest?.id ?? 0),
		});
	},
	reset: () => set({ newCount: 0, seenId: null }),
}));

// Starts the polling for a master; mounted once, in the header.
export const useInterestPolling = user => {
	const isMaster = user?.role === 'master';
	useEffect(() => {
		const { refresh, reset } = useInterestStore.getState();
		if (!isMaster) {
			reset();
			return;
		}
		refresh();
		const id = setInterval(refresh, POLL_MS);
		return () => clearInterval(id);
	}, [isMaster]);
};
